import { getIn } from "formik";
import { useState } from "react";
import EyeSlashIcon from "../../icons/eyeSlashIcon";
import EyeIcon from "../../icons/eyeIcon";
const BoardTextInput = ({
  label,
  id,
  placeholder,
  name,
  number,
  formik,
  type = "text",
  disabled,
  onChange,
  showError,
  onBlur,
  icon,
}) => {
  const required = Object.keys(formik.initialValues).some((key) => key === name);
  const nestedError = getIn(formik.errors, name);
  const nestedTouched = getIn(formik.touched, name);
  const handleKeyDown = (e) => {
    if (
      number &&
      !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key) &&
      !/^[0-9]$/.test(e.key)
    ) {
      e.preventDefault();
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="relative w-full mb-4">
      {label && (
        <label
          className="block mb-1 font-medium capitalize dark:text-white text-mainGray"
          htmlFor={id}
        >
          {label}
          {label && required && <span className="text-mainRed">*</span>}
        </label>
      )}
      <div className="border-[#E5E7FB] border focus-within:border-black rounded-[5px] overflow-hidden flex items-center gap-1 px-2 bg-white">
        {icon ? icon : null}
        <input
          type={type === "password" && showPassword ? "text" : type}
          name={name}
          placeholder={placeholder}
          onChange={onChange || (formik && formik.handleChange)}
          onBlur={onBlur || (formik && formik.handleBlur)}
          value={formik.getFieldProps(name)?.value || ""}
          disabled={disabled}
          className="w-full p-2 h-[40px] focus-visible:outline-none"
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
        {type === "password" && (
          <span onClick={() => setShowPassword((s) => !s)}>
            {showPassword ? <EyeSlashIcon /> : <EyeIcon className="size-[28px]" />}
          </span>
        )}
        {(showError || !disabled) && nestedError && (showError || nestedTouched) && (
          <span className="text-[12px] text-mainRed absolute">{nestedError}</span>
        )}
      </div>
    </div>
  );
};

export default BoardTextInput;
